import React, { useState, useRef, useEffect } from 'react';
import { MessageCircle, ArrowRight, Play } from 'lucide-react';
import { engineerInfo } from '../../mock';
import { Button } from '../ui/button';

const VideoSection = () => {
  const [showButton, setShowButton] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      if (video.currentTime >= 20 && !showButton) {
        setShowButton(true);
      }
    };

    const handlePlay = () => {
      setIsPlaying(true);
    };

    const handlePause = () => {
      setIsPlaying(false);
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('play', handlePlay);
    video.addEventListener('pause', handlePause);

    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('play', handlePlay);
      video.removeEventListener('pause', handlePause);
    };
  }, [showButton]);

  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="bg-gradient-to-br from-[#073A40] to-[#06323B] rounded-2xl overflow-hidden shadow-2xl border-4 border-[#073A40]">
            <div className="relative mx-auto bg-gradient-to-br from-[#073A40] to-[#06323B]" style={{ width: '100%', maxWidth: '480px' }}>
              <div style={{ paddingBottom: '176.67%', position: 'relative' }}>
                <video 
                  ref={videoRef}
                  className="absolute inset-0 w-full h-full object-cover"
                  controls
                  playsInline
                  style={{ backgroundColor: '#000' }}
                >
                  <source src={engineerInfo.creativeVideo} type="video/mp4" />
                  Seu navegador não suporta vídeos.
                </video>
                {!isPlaying && (
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-20 h-20 bg-[#A69076] rounded-full flex items-center justify-center hover:scale-110 transition-all shadow-xl">
                      <Play className="text-white ml-2" size={36} fill="currentColor" />
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            <div className="p-6 sm:p-8 text-center bg-gradient-to-br from-[#073A40] to-[#06323B]">
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
                Precisa de um Profissional de Confiança?
              </h3>
              <p className="text-lg sm:text-xl text-[#F2F2F2] mb-6 font-medium">
                Entre em contato agora e receba seu orçamento personalizado
              </p>
              
              <div 
                className={`transition-all duration-500 ${
                  showButton 
                    ? 'opacity-100 transform translate-y-0' 
                    : 'opacity-0 transform translate-y-4 pointer-events-none'
                }`}
              >
                <Button 
                  asChild
                  size="lg"
                  className="bg-[#A69076] hover:bg-[#A69F97] text-white font-bold text-lg sm:text-xl px-10 py-7 transition-all duration-300 shadow-lg hover:shadow-xl animate-pulse"
                >
                  <a href={engineerInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                    <MessageCircle size={24} className="mr-2" />
                    Falar no WhatsApp Agora
                    <ArrowRight size={24} className="ml-2" />
                  </a>
                </Button>
              </div>
              
              {!showButton && (
                <p className="text-sm text-[#A69076] mt-4 font-semibold">
                  Assista ao vídeo para saber mais...
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
